import { Skeleton } from 'antd';

import { KPISkeletonContainer } from './KPISkeleton.styles';

interface KPISkeletonProps {
  children: React.ReactNode;
  loading: boolean;
  withSliderSkeleton?: boolean;
  width?: number;
  height?: number;
  [x: string]: unknown;
}

const KPISkeleton = ({
  children,
  loading,
  withSliderSkeleton = true,
  width = 100,
  height = 50,
  ...rest
}: KPISkeletonProps) => {
  return loading ? (
    <KPISkeletonContainer {...rest}>
      <Skeleton.Node active style={{ width, height }} />
      {withSliderSkeleton && <Skeleton active title={{ width: 250 }} paragraph={false} rootClassName="kpi-skeleton" />}
    </KPISkeletonContainer>
  ) : (
    children
  );
};

export default KPISkeleton;
